import { render, staticRenderFns } from "./reports-talktime-column-graph.vue?vue&type=template&id=5f56423c"
import script from "./reports-talktime-column-graph.vue?vue&type=script&lang=js"
export * from "./reports-talktime-column-graph.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports